import { useState } from "react";
import { Outlet } from "react-router-dom";
import ContentWrapper from "../../../../core/ui/components/Layout/ContentWrapper";

const ReservasLayout = () => {
    const [sedeId, setSedeId] = useState(null);
    const [recursoId, setRecursoId] = useState(null);

    return (
        <ContentWrapper>
            <div className="content-heading">
                <div>RESERVAS</div>
            </div>
            <Outlet context={{ sedeId, setSedeId, recursoId, setRecursoId }} />
        </ContentWrapper>
    );
};

export default ReservasLayout;